import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Masquerade() {
  return <ImageCollectionPage title="Masquerade" path="/culture/masquerade" collection="culture_masquerade" />;
}
